import React, { useRef } from 'react'
import { useGLTF, PerspectiveCamera, OrbitControls, Environment } from '@react-three/drei'

const MODEL_PATH = './models/Chair_V2.glb'
const HDR_PATH = './models/christmas_photo_studio_01_2k.hdr'

export const Materials = {
    brown : 'M_Brown',
    black: 'M_Black',
    red: 'M_Red',
    fabricFlower: 'M_Fabric_flower',
    fabricStrips: 'M_Fabric_strip',
    fabricYellow: 'M_Fabric_yellow'
}

export const PillowFabrics = {
    flower: 'M_Fabric_flower',
    strip: 'M_Fabric_strip',
    yellow: 'M_Fabric_yellow'
}

export const ChairBackShape = {
    heart : 'Chair_Heart',
    leaf: 'Chair_leaf',
    cloud: 'Chair_Cloud'
}



const ChairModel = (props) => {

    const { nodes, materials, cameras } = useGLTF(MODEL_PATH)

    const controlRef = useRef()
    
    const meshs = Object.entries(nodes).filter(val => val[1].type === 'Mesh');
    const focus = meshs[0][1].position

    
    return (
        <>

            <pointLight power={140} position={focus} distance={500} intensity={2} />
            <ambientLight intensity={1.5} />
    
            <Environment files={HDR_PATH} background={true} />   
            
                <PerspectiveCamera makeDefault position={cameras[0].parent.position} quaternion={cameras[0].parent.quaternion} scale={cameras[0].parent.scale} />

                <group  {...props}>
                   
                        <mesh visible={props.pillowVisible} geometry={nodes['Pillow'].geometry} material={materials[props.pillowFabric]} position={nodes['Pillow'].position} rotation={nodes['Pillow'].rotation} />                    
                        <mesh geometry={nodes[props.chariPattern].geometry} material={materials[props.chairMaterial]} position={nodes['Chair_leaf'].position} rotation={nodes['Chair_leaf'].rotation}  /> 
                    
                </group>

                <OrbitControls ref={controlRef}  target={focus} />

        </>
    )
}



export default ChairModel


useGLTF.preload(MODEL_PATH)
